<div>
  <!-- app-landing-header></app-landing-header -->
  <div class="main-panel-landing">
    <router-outlet></router-outlet>
  </div>
</div>
